import { Badge } from 'antd';
import styles from './activeStatus.module.less';

type ActiveStatusProps = {
	status: string;
};
export default function ActiveStatus({ status }: ActiveStatusProps) {
	return (
		<Badge
			text={status}
			className={status === 'Active' ? styles.active : styles.deactivated}
			color={'green'}
		>
  </Badge>
	);
}
